/**
 * share-kinds — ЕДИНЫЙ реестр видов виральных крючков Студии (П9).
 *
 * Вид крючка живёт в трёх местах разом: сервер mobile-gw (SHARE_KINDS — тексты
 * сообщения-приглашения), роутер панели (App.tsx — какие startapp-префиксы вести в
 * студию) и ревил гостя (InviteReveal — обрамление). До реестра список дублировался
 * литералами: новый вид без правки ВСЕХ точек = тихо мёртвая ссылка (гость приземлялся
 * на «/» и ничего не происходило). Теперь имена видов — только здесь; сервер типизирует
 * свои тексты `Record<StudioShareKind, …>` (пропуск вида = ошибка компиляции), роутер
 * матчит префикс хелпером.
 *
 * Формат deep-link: `startapp=<kind>_<id>`, id ∈ [A-Za-z0-9_-] (charset Telegram).
 *
 * Вид `code` (11.08.2026, «личный код совместимости», заказ ректора по идее Виталика):
 * ВЕЧНАЯ персональная ссылка `pair_u<userId>` (chat-путь реки знакомств, НЕ startapp) —
 * в реестре живёт ради текстов prepared-сообщения и карточки; startapp-ссылок вида
 * `code_<id>` не существует by design.
 */
// 'pair' — вечный личный код (`pair_u<userId>`, personal-pair-invite): ЧАТ понимал его
// всегда (parseInviteToken берёт kind из ЗАПИСИ), а ПАНЕЛЬ до 19 авг 2026 — нет, и
// кнопка «Открыть форму» приземляла гостя в дефолтную панель мимо астро-приземления
// (прожито ректором). Одно множество токенов для всех морд (П9).
export const STUDIO_SHARE_KINDS = ['daily', 'synastry', 'reading', 'gift', 'code', 'pair'];
/** startapp-параметр — виральный инвайт студии? (`<kind>_<id>` с известным kind). */
export function isStudioShareStartParam(param) {
    if (typeof param !== 'string')
        return false;
    return STUDIO_SHARE_KINDS.some((k) => param.startsWith(`${k}_`) && param.length > k.length + 1);
}
//# sourceMappingURL=share-kinds.js.map